import React from "react";

import "./Tabs.scss";

const Tabs = (props) => {
  const { items, active, onClickTab } = props;

  const [activeTab, setActiveTab] = React.useState(active || 0);

  React.useEffect(() => {
    setActiveTab(active || 0);
  }, [active]);

  const handleActiveTab = (id) => {
    setActiveTab(id);
    onClickTab?.(id);
  };

  const children = [];
  React.Children.forEach(props.children, (child, i) => {
    if (child) {
      children.push(child);
    }
  });

  return (
    <div className="Tabs">
      <div className="nav-tabs">
        {items?.map((item, index) => (
          <span
            key={index}
            className={`nav-item ${activeTab === index ? "active" : ""}`}
            onClick={() => handleActiveTab(index)}
          >
            {item}
          </span>
        ))}
      </div>
      <div className="content-tabs">{children?.[activeTab]}</div>
    </div>
  );
};

export default Tabs;
